"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const material_1 = require("@angular/material");
const forms_1 = require("@angular/forms");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const http_1 = require("@angular/common/http");
const file_manager_service_1 = require("../../../../service/file-manager.service");
const app_service_1 = require("../../../../commons/app.service");
const map_service_1 = require("../../../../commons/map.service");
const core_2 = require("@ngx-translate/core");
const AppBaseComponent_1 = require("../../../../commons/AppBaseComponent");
const ngx_stripe_1 = require("ngx-stripe");
const application_events_service_1 = require("../../../../xs/services/events/application-events.service");
class PaymentComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, r, sn, d, ar, t, trans, fb, cd, fileManager, dialogRef, snackBar, mapService, data, httpClient, stripeService, applicationEvents
    // private stripeFactory: StripeFactoryService
    ) {
        super(service, r, sn, d, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.r = r;
        this.ar = ar;
        this.t = t;
        this.trans = trans;
        this.fb = fb;
        this.cd = cd;
        this.fileManager = fileManager;
        this.dialogRef = dialogRef;
        this.snackBar = snackBar;
        this.mapService = mapService;
        this.data = data;
        this.httpClient = httpClient;
        this.stripeService = stripeService;
        // optional parameters
        this.elementsOptions = {
            locale: 'auto'
        };
    }
    init() {
        this.stripeTest = this.fb.group({
            name: ['', [forms_1.Validators.required]]
        });
        // this.stripe = this.stripeFactory.create('pk_test_PEfNqLj0cgu6mRflQPo81oVq');
        //this.stripeService.setKey('pk_test_PEfNqLj0cgu6mRflQPo81oVq');
        // const Stripe$: Observable<any> = this.stripeService.getStripeReference();
        // this is a reference to the stripe elements object
        // const stripe = this.stripeService.getInstance();
        this.stripeService.elements(this.elementsOptions)
            .subscribe(elements => {
            this.elements = elements;
            // Only mount the element the first time
            if (!this.card) {
                this.card = this.elements.create('card', {
                    style: {
                        base: {
                            iconColor: '#666EE8',
                            color: '#31325F',
                            lineHeight: '40px',
                            fontWeight: 300,
                            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                            fontSize: '18px',
                            '::placeholder': {
                                color: '#CFD7E0'
                            }
                        }
                    }
                });
                this.card.mount('#card-element');
            }
        });
    }
    buy() {
        const name = this.stripeTest.get('name').value;
        this.stripeService
            .createToken(this.card, { name })
            .subscribe(result => {
            if (result.token) {
                // Use the token to create a charge or a customer
                // https://stripe.com/docs/charges
                console.log(result.token);
            }
            else if (result.error) {
                // Error creating the token
                console.log(result.error.message);
            }
        });
    }
    buyPlan() {
        const name = this.stripeTest.get('name').value;
        var ownerInfo = {
            owner: {
                email: 'haresh.aprajapati@4dmapper.com',
                name: 'haresh',
                phone: 'haresh',
                address: {
                    city: 'Berlin',
                    line1: 'Nollendorfstraße 27',
                    postal_code: '10777',
                    country: 'DE',
                    line2: '',
                    state: ''
                }
            },
        };
        this.stripeService
            .createSource(this.card, ownerInfo)
            .subscribe(result => {
            if (result.source) {
                // Use the token to create a charge or a customer
                // https://stripe.com/docs/charges
                console.log(result.source);
            }
            else if (result.error) {
                // Error creating the token
                console.log(result.error.message);
            }
        });
    }
    submit() {
        return;
    }
    payment() {
        /*
        var Simplify = require("simplify-commerce");
       var client = Simplify.getClient({
          publicKey: 'sbpb_ZTAzODAyNzEtYzhjNi00NDQ1LTg3NGEtMjgzMWY3OTU0ZWYx',
          privateKey: 'vtXprAoMAphNZOHZdlAXCmjjyG4qveV+ZUDCHLRo3oh5YFFQL0ODSXAOkNtXTToq'
        });
    
        client.cardtoken.create({
          card : {
            addressState : "MO",
            expMonth : "11",
            expYear : "19",
            addressCity : "OFallon",
            cvc : "123",
            number : "5105105105105100"
          }
        }, function(errData, data){
    
          if(errData){
            console.error("Error Message: " + errData.data.error.message);
            // handle the error
            return;
          }
    
          console.log("Success Response: " + JSON.stringify(data));
        });*/
    }
}
exports.PaymentComponent = PaymentComponent;
